<script setup>
import { computed } from 'vue'
import { useTimer } from '../composables/useTimer.js'
import {
    useTiers,
    getTierColorClasses,
    getTierBgClass,
} from '../composables/useTiers.js'
import { useButtonEvent } from '../composables/useButtonEvent.js'

const props = defineProps({
    seconds: { type: Number, required: true },
    tiers: { type: Array, default: () => [] },
})

// Composables
const { timer, resetTimer } = useTimer(props.seconds)
const tiersRef = computed(() => props.tiers)
const { currentTier, otherTiers } = useTiers(tiersRef, timer)

useButtonEvent(() => resetTimer())
</script>

<template>
    <div class="c-tiers">
        <!-- Current Tier - Large and prominent -->
        <div v-if="currentTier" class="c-tiers__current">
            <div
                class="c-tiers__current-icon"
                :class="getTierColorClasses(currentTier.value)"
            >
                <span class="c-tiers__current-icon-label">{{
                    currentTier.label
                }}</span>
            </div>

            <h3 class="c-tiers__current-title">
                {{ currentTier.label }} Achievement
            </h3>

            <div class="c-tiers__current-badge">Current Tier</div>
        </div>

        <div class="c-tiers__list-section">
            <p class="c-tiers__list-header">Other Milestones</p>
            <div class="c-tiers__list">
                <div
                    v-for="tier in otherTiers"
                    :key="tier.value"
                    class="c-tiers__item"
                    :class="[
                        getTierBgClass(tier.value),
                        timer >= tier.seconds
                            ? 'c-tiers__item--unlocked'
                            : 'c-tiers__item--locked',
                    ]"
                >
                    <div
                        class="c-tiers__item-icon"
                        :class="getTierColorClasses(tier.value)"
                    >
                        <span class="c-tiers__item-icon-label">{{
                            tier.label
                        }}</span>
                    </div>
                    <span class="c-tiers__item-label">{{ tier.label }}</span>
                </div>
            </div>
        </div>
    </div>
</template>
